import { Heading2 } from 'components/shared/Typography.styled';
import styled from 'styled-components';
import { container, spacing } from '../../../theme';

export const StyledContainer = styled.section`
  max-width: ${container('xl')};
  margin: auto;
  padding: ${spacing('xl4')} ${spacing('md')};

  ${Heading2} {
    text-align: center;
  }
`;

export const StyledGrid = styled.div`
  margin-top: ${spacing('xl4')};
  .masonry-grid {
    display: flex;
    margin-left: -${spacing('xl')}; /* gutter size offset */
    width: auto;
  }
  .masonry-column {
    padding-left: ${spacing('xl')}; /* gutter size */
    background-clip: padding-box;

    &:empty {
      display: none;
    }

    > div {
      margin-bottom: ${spacing('xl')};
    }
  }
`;
